const getImageUploaderErrorTexts = (variant, intl) => {
	switch (variant) {
		case 'overLimit':
			return intl.formatMessage({ id: 'app.designer.image-oversize' }).split(/\.\s(.+)/)[0];
		case 'overLimitSec':
			return intl.formatMessage({ id: 'app.designer.image-oversize' }).split(/\.\s(.+)/)[1];
		case 'wrongFormat':
			return intl.formatMessage({ id: 'app.designer.image-format' });
		case 'wrongFormatSec':
			return intl.formatMessage({ id: 'app.designer.image-wrong-format' });
		default:
			return '';
	}
};

export default getImageUploaderErrorTexts;
